import { render, staticRenderFns } from "./ContractorsAddresses.vue?vue&type=template&id=05e168f3&"
import script from "./ContractorsAddresses.vue?vue&type=script&lang=js&"
export * from "./ContractorsAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports